function useDetectKeelMind(ignoreSlashMind = false) {
    return (
        window.location.hostname.includes("keelmind.com") ||
        (!ignoreSlashMind && window.location.pathname.includes("mind"))
    );
}

export default useDetectKeelMind;
